import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { I18nService } from '@app/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '@app/auth.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  error: string;
  isLoading = false;
  member_obj: any;
  obj_data_all: any;
  url: any;
  ip_add: any;

  form: FormGroup
  submitted = false

  returnUrl = ""

  cookieData: any
  cookieUser: any
  cookiePass: any

  get formControl() {
    return this.form.controls;
  }

  constructor(private Auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private i18nService: I18nService,
    private util: UtilService,
    private apiService: ApiService,
    private fb: FormBuilder) {
      this.form = this.fb.group({
        username: ['', Validators.required],
        password: ['', Validators.required]
      });
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == "Enter") {
      this.Login();
    }
  }

  async ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];

    let ck: any = JSON.parse(localStorage.getItem("dpa_cc"))
    if (ck == null) {
      localStorage.setItem("dpa_cc", "{}")
      this.cookieData = {}
    }
    else {
      this.cookieData = ck
    }

    let getKeyRes: any = await this.apiService.getKey()
    
    
    this.cookieData.pbk = getKeyRes
    localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))

    this.route.queryParams.subscribe(params => {
      this.cookieUser = params['user'];
      this.cookiePass = params['pass'];
    });

    if (this.cookieUser != null && this.cookieUser != undefined){
      this.form.controls["username"].setValue(this.cookieUser);
      this.form.controls["password"].setValue(this.cookiePass);
      this.Login();
    }
    
  }

  async Login() {
    try {
      this.submitted = true
      if(this.form.valid){
        this.util.ShowWaiting(true)
        let res:any = await this.apiService.post("crmservice", "callcenterLogin", this.form.value)
        if (this.util.isSuccessResponse(res)) {
          if(res.RESCODE == "0" && res.RESMSG == "SUCCESS"){
            this.loginCallcenter();
          }
          else if (res.RESCODE == "Y" && res.RESMSG == "SUCCESS"){
            if (this.cookieUser != null && this.cookieUser != undefined){
              this.loginCallcenter();
            }else {
              //let url: string = this.util.baseUrl() + "/changePassword"
              //window.open(url)
              let user: any = await this.apiService.get("crmservice", "callcenterProfile", "username=" + this.form.get("username").value)
              let roleList: any = await this.apiService.get("master", "customwebrole")
              

              let role = roleList.filter((r:any)=>{
                return r.dpa_customwebroleid == user[0].dpa_roleid
              })

              let dpa_cc = {
                "userId": user[0].dpa_customwebuserid,
                "userRole": role[0].dpa_customwebroleid,
                "username": this.form.get("username").value,
                "role": JSON.stringify(role[0]),
                "dpa_name": user[0].dpa_name,
                "teams": JSON.stringify(user[0].dpa_teamidlist)
              }
              localStorage.setItem("dpa_cc", JSON.stringify(dpa_cc))
              localStorage.setItem("returnUrl", this.returnUrl)
              localStorage.setItem("role", JSON.stringify(role[0]))
              this.router.navigate(["/setChangePassword"])
            }
          }
          else{
            this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง")
          }
        }
        else{
          this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง")
        }
      }
      this.util.ShowWaiting(false)

    } catch (ex) {
      this.util.ShowWaiting(false);
      this.util.ErrorDialog(ex);
    }
  }

  async  CheckSession() {
    var str = '';
    $('#divData').html(str);
    var data = {}
    data['member_no'] = $('#txtUserName').val();
    var res: any = await this.apiService.postnotauthen('account', 'GetUserSession', data);
    this.util.ShowWaiting(false);
    var check = 0;
    if (res.isSuccess) {
      if (res.responseData != null) {
        if (res.responseData.length > 0) {
          check++;
          this.ip_add = res.responseData[0].ip_address;
        }
      }
    }
    if (check == 0) {
      var res2: any = await this.apiService.postnotauthen('account', 'InsertUserSession', data);
      this.VisitApp(this.url);
    } else {
      this.util.ErrorDialog("user นี้ถูกใช้งานอยู่ (ip:" + this.ip_add + ")");
    }
  }

  VisitApp(url: any) {
    // window.location.href = url;
    
    this.router.navigate([url]);
  }


  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  resetPassword() {
    let url = this.util.baseUrl() + "/resetPassword"
    window.open(url, "_blank")
  }

  clear(){
    this.form.controls["username"].setValue("")
    this.form.controls["password"].setValue("")
    this.submitted = false
  }

  async loginCallcenter(){
    let user: any = await this.apiService.get("crmservice", "callcenterProfile", "username=" + this.form.get("username").value)
    let roleList: any = await this.apiService.get("master", "customwebrole")
    

    let role = roleList.filter((r:any)=>{
      return r.dpa_customwebroleid == user[0].dpa_roleid
    })

    let dpa_cc = {
      "userId": user[0].dpa_customwebuserid,
      "userRole": role[0].dpa_customwebroleid,
      "username": this.form.get("username").value,
      "role": JSON.stringify(role[0]),
      "dpa_name": user[0].dpa_name,
      "teams": JSON.stringify(user[0].dpa_teamidlist)
    }//role[0].dpa_name
    localStorage.setItem("dpa_cc", JSON.stringify(dpa_cc))

    this.util.ShowWaiting(false)
    if(this.returnUrl){
      this.router.navigateByUrl(this.returnUrl);
    }
    else if(role[0].dpa_tab_poolcase){
      this.router.navigate(["/mainmenu/pool"])
    }
    else if(role[0].dpa_tab_allcase){
      this.router.navigate(["/mainmenu/shared"])
    }
    else if(role[0].dpa_tab_case){
      this.router.navigate(["/mainmenu/case"])
    }
    else if(role[0].dpa_tab_contact){
      this.router.navigate(["/mainmenu/contact"])
    }
    else if(role[0].dpa_tab_chatbot){
      this.router.navigate(["/mainmenu/chatbot"])
    }
    else if(role[0].dpa_tab_socialmonitoring){
      this.router.navigate(["/mainmenu/socialMedia"])
    }
    else if(role[0].dpa_tab_km){
      this.router.navigate(["/mainmenu/knowledge"])
    }
    else if(role[0].dpa_tab_report){
      this.router.navigate(["/mainmenu/report"])
    }
    else{
      this.router.navigate(["/mainmenu"])
      this.util.WarningDialog("คุณไม่มีสิทธิ์เข้าใช้เมนู")
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts